import { FC } from 'react';

import { Root } from './PayHeader.Root';
import { Title } from './PayHeader.Title';
import { SubTitle } from './PayHeader.SubTitle';

export const PayHeader: FC<{
  title: string;
  subtitle?: string;
}> = ({ title, subtitle }) => {
  return (
    <Root>
      <Title>{title}</Title>
      {subtitle && <SubTitle>{subtitle}</SubTitle>}
    </Root>
  );
};
